<template>
    <div>
        <CRow>
            <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
                <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
                    caption="Lista de Pagos" icon="fas fa-coins" btn_name="Pago" @mtdBack="mtdBack"
                    @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'"
                    :button_new="true" :actions="true" :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
            </CCol>
        </CRow>

        <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
            :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
            <CRow>
                <CCol sm="12">
                    <cSelectForm label="Empresa" placeholder="Seleccione empresa" :options="data_companies"
                        :value.sync="payment.company_id" />
                </CCol>
                <CCol sm="12">
                    <CInput label="Serie de Boleta o Factura" placeholder="Digite serie del documento"
                        v-model="payment.serie_document" />
                </CCol>
                <CCol sm="12">
                    <CInput label="Número de Boleta o Factura" placeholder="Digite número del documento"
                        v-model="payment.nro_document" />
                </CCol>
                <CCol sm="12">
                    <CInput label="Monto de Pago del Sistema" placeholder="00.00" type="number"
                        v-model="payment.amount_payment_system" />
                </CCol>
                <CCol sm="12">
                    <CInput label="Monto de Pago de las factura" placeholder="00.00" type="number"
                        v-model="payment.amount_payment_documents" />
                </CCol>
                <CCol sm="12">
                    <CTextarea label="Descripción" placeholder="ingrese descripción..." rows="8"
                        v-model="payment.description" />
                </CCol>
                <!-- <CCol v-if="modal.action != 'store'" sm="12">
                    <label for="">Estado</label>
                    <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
                        :checked="campu.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
                        v-bind="labelIcon" />
                </CCol> -->
            </CRow>
        </CModalForm>

        <!-- modal delete -->
        <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Rol'"
            :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
    </div>
</template>
<script>
const fields = [
    { key: "index", label: "ID", _style: "width:1%" },
    { key: "name_company", label: "Empresa", _style: "width:1%" },
    { key: "serie_document", label: "Serie de Boleta o Factura", _style: "width:1%" },
    { key: "nro_document", label: "N° Boleta o Factura", _style: "width:1%" },
    { key: "amount_payment_system", label: "Monto del sistema", _style: "width:1%" },
    { key: "amount_payment_documents", label: "Monto del facturación", _style: "width:1%" },
    { key: "total", label: "Total", _style: "width:1%" },
    { key: "description", label: "Descripción", _style: "width:1%" },

];

import { mapActions } from "vuex";
import CTableWrapper from "../../components/shared/datatable/Table.vue";
import CModalForm from "../../components/shared/modals/cModalForm.vue";
import cSelectForm from '../../components/shared/inputs/cSelect.vue';
import cModalDelete from "../../components/shared/modals/cModalDelete.vue";


export default {
    components: {
        CTableWrapper,
        CModalForm,
        cSelectForm,
        cModalDelete
    },
    data() {
        return {
            prefix: "payments",
            fields,
            data: [],
            data_companies: [],
            modal: {
                action: "",
                title: "",
                modal_form: false,
            },
            modal_delete: {
                boo: false,
                item: [],
            },
            payment: {
                Id: "",
                company_id: "",
                serie_document: "",
                nro_document: "",
                amount_payment_system: 0,
                amount_payment_documents: 0,
                description: "",
            }
        }
    },
    computed: {
        cp_button: function () {
            if (
                this.payment.serie_document != "" &&
                this.payment.nro_document != "" &&
                this.payment.amount_payment_system != "" &&
                this.payment.amount_payment_documents != "" &&
                this.payment.description != ""
            ) return false;
            return true;
        },
    },
    created() {
        this.getData();
        this.getCompanies();
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdBack: function () {
            this.$emit("mtdBack");
        },
        getData() {
            this.get({
                url: this.$store.getters.get__url + "/" + this.prefix + "/index",
                token: this.$store.getters.get__token,
            }).then(response => {
                this.data = response.data;
                let index = 1;
                this.data.forEach((arr) => {
                    arr.Id = arr.id;
                    arr.name_company = arr.company.name;
                    arr.index = index;
                    index++;
                });
            });
        },
        getCompanies() {
            this.get({
                url: this.$store.getters.get__url + "/" + this.prefix + "/byCompanies",
                token: this.$store.getters.get__token,
            }).then(response => {
                response.data.forEach((elemet) => {
                    this.data_companies.push({
                        label: elemet.name,
                        value: elemet.id,
                    });
                });
            });
        },
        mtd_open_modal: function (boo, action) {
            this.modal.modal_form = boo;
            this.modal.action = action;
            action == "store"
                ? (this.modal.title = "Nueva Pago")
                : (this.modal.title = "Editar Pago");
            action == "store"
                ? (this.payment = {
                    id: "",
                    company_id: "",
                    serie_document_document: "",
                    nro_document: "",
                    amount_payment_system: 0,
                    amount_payment_documents: 0,
                    description: "",
                })
                : (this.payment = { ...this.payment });
            if (this.modal.action != 'store') {
                this.componentKey += 1;
            }
        },
        closeModal() {
            this.modal.modal_form = false;
        },
        mtd_show: function (id) {
            this.get({
                url: this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
                token: this.$store.getters.get__token,
            })
                .then((response) => {
                    this.payment = response;
                    this.mtd_open_modal(true, "update");
                })
        },
        mtd_action() {
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/" + this.modal.action,
                token: this.$store.getters.get__token,
                params: this.payment,
            }).then((response) => {
                if (response.statusCode == 200) {
                    Swal.fire({
                        title: "Pago registrado correctamente",
                        icon: "success",
                    });
                    this.closeModal();
                    this.getData();
                }
            })
        },
        mtd_delete(item) {
            this.modal_delete.boo = true;
            this.modal_delete.item = item;
        },
        mtd_commit() {
            this.post({
                url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
                token: this.$store.getters.get__token,
                params: {
                    id: this.modal_delete.item.Id,
                },
            }).then((response) => {
                if (response.statusCode == 200) {
                    Swal.fire({
                        title: "Eliminado correctamente",
                        icon: "success"
                    })
                    this.getData();
                    this.modal_delete.boo = false;
                }
            });
        }
    }
}
</script>